<div *ngIf="sampleList && sampleList.length > 0; else noSample">

  <div class="row m-3" *ngFor="let sample of sampleList">

    <!-- 1️⃣ Identification et référence -->
    <div class="col-md-4 mt-3">
      <span class="label">Code d'Échantillon :</span>
      <p>{{ sample.sampleCode }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Type d'Échantillon :</span>
      <p>{{ sample.typeSampleName }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Référence interne :</span>
      <p>{{ sample.referenceInterne }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Référence du lot :</span>
      <p>{{ sample.batchReference ? sample.batchReference : '-' }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Priorité :</span>
      <p>{{ sample.priorite }}</p>
    </div>

    <!-- 2️⃣ Client et département -->
    <div class="col-md-4 mt-3">
      <span class="label">Client :</span>
      <p>{{ sample.clientName }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Département :</span>
      <p>{{ sample.departementName }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Terrain :</span>
      <p>{{ sample.terrainVarPlante ? sample.terrainVarPlante : '-' }}</p>
    </div>

    <!-- 3️⃣ Personnes impliquées -->
    <div class="col-md-4 mt-3">
      <span class="label">Collecté par :</span>
      <p>{{ sample.collectedByUsername }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Créé par :</span>
      <p>{{ sample.createdByUsername }}</p>
    </div>

    <!-- 4️⃣ Dates importantes -->
    <div class="col-md-4 mt-3">
      <span class="label">Date de production :</span>
      <p>{{ sample.dateProduction | date:'shortDate' }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Date limite de consommation :</span>
      <p>{{ sample.dateLimiteConsommation | date:'shortDate' }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Date de réception :</span>
      <p>{{ sample.dateReception | date:'short' }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Création :</span>
      <p>{{ sample.dateCreation | date:'short' }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Mise à jour :</span>
      <p>{{ sample.updateDate ? (sample.updateDate | date:'short') : 'Non mis à jour' }}</p>
    </div>

    <!-- 5️⃣ Statut et validation -->
    <div class="col-md-4 mt-3">
      <span class="label">Statut :</span>
      <p>{{ sample.sampleStatus }}</p>
    </div>

    <!-- 6️⃣ Conditions et propriétés -->
    <div class="col-md-4 mt-3">
      <span class="label">Condition d'Échantillon :</span>
      <p>{{ sample.conditionnement ? sample.conditionnement : '-' }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Volume :</span>
      <p>{{ sample.volume ? sample.volume : '-' }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Température de prélèvement :</span>
      <p>{{ sample.temperaturePrelevement ? sample.temperaturePrelevement + ' °C' : '-' }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Température de réception :</span>
      <p>{{ sample.temperatureReception ? sample.temperatureReception + ' °C' : '-' }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Scellé :</span>
      <p>{{ sample.scelle ? 'Oui' : 'Non' }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Scellé intact :</span>
      <p>{{ sample.scelleIntact ? sample.scelleIntact : '-' }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Volume suffisant :</span>
      <p>{{ sample.volumeSuffisant ? sample.volumeSuffisant : '-' }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Propreté / Contamination :</span>
      <p>{{ sample.propreteContamination ? sample.propreteContamination : '-' }}</p>
    </div>

    <!-- 7️⃣ Méthode et analyse -->
    <div class="col-md-4 mt-3">
      <span class="label">Méthode :</span>
      <p>{{ sample.methodeName ? sample.methodeName : '-' }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Matrice :</span>
      <p>{{ sample.matriceName ? sample.matriceName : '-' }}</p>
    </div>

    <div class="col-md-4 mt-3">
      <span class="label">Type d'analyse :</span>
      <p>{{ sample.typeAnalyseName ? sample.typeAnalyseName : '-' }}</p>
    </div>

    <hr class="mt-3">

  </div>

</div>

<ng-template #noSample>
  <div class="no-client-details mx-3 mt-3 w-5">
    <p>Aucun échantillon n'est disponible.</p>
  </div>
</ng-template>